<template>
  <div class="bg-gray">
   <navigation-bar />
    <div class="container-fluid">
      <h1 class="text-left" style="margin-top:20px;">My Account</h1>
      <div class="row">
        <div class="col-sm-6">
          <div class="form-group">
            <label>First Name</label>
            <input class="form-control" v-model="store.state.user.first_name" />
          </div>
        </div>
        <div class="col-sm-6">
          <div class="form-group">
            <label>Last Name</label>
            <input class="form-control" v-model="store.state.user.last_name" />
          </div>
        </div>
        <div class="col-sm-6">
          <div class="form-group">
            <label>Email</label>
            <input class="form-control" v-model="store.state.user.email" autocomplete="off" />
          </div>
        </div>
        <div class="col-sm-6" v-show="store.state.user.facebookId == '' || store.state.user.facebookId == null">
          <div class="form-group">
            <label>Password</label>
            <input type="password" class="form-control" v-model="store.state.user.password" autocomplete="off" />
          </div>
        </div>
        <div class="col-sm-12">
          <button @click="updateUser" class="btn btn-primary btn-blue" style="margin-top:10px;margin-bottom:20px;width:150px;">Save</button>
        </div>
        <div class="col-sm-12" v-if="store.state.user.emailConfirmed == 0">
          <hr>
          <h2>Confirm Email Address</h2>
          <p>You have not confirmed your email address yet, would you like us to email you now?</p>
          <button @click="sendEmail" class="btn btn-primary btn-orange" style="margin-top:10px;margin-bottom:20px;">Send Link To Email</button>
        </div>
      </div>
    </div>
    <dashboard-footer></dashboard-footer>
  </div>
</template>

<script>
import NavigationBar from "../nav/NavigationBar";
import DashboardFooter from "../nav/Footer";
import Utils from "@/Utils/Utils";
import Navigator from "@/router/navigator";
import MyAccountStore from "./MyAccountStore";
import AccountSessionUtils from "./AccountSessionUtils";
import moment from 'moment'

export default {
  name: "ConfirmEmail",
  components: {
    NavigationBar,
    DashboardFooter
  },
  data() {
    return {
      nav: Navigator,
      store: MyAccountStore,
      accountUtils: AccountSessionUtils,
      utils: Utils
    };
  },
  mounted() {
    this.store.reset()
    this.accountUtils.authorize(
      userId => {
        this.store.state.currentUserId = userId;
        if (userId == "0") {
          this.nav.goLogin(this,"MyAccount");
          return;
        }
        this.getUser();
      },
      err => {
        this.$toasted.show(err, { type: "error", duration: 2500 });
      }
    );
  },
  computed: {},
  methods: {
    getUser() {
      this.store.getUser(
        data => {
        },
        err => {
          this.$toasted.show(err, { type: "error", duration: 2500 });
        }, () => {
        this.nav.goMaintenance(this)
        }
      );
    },
    updateUser() {
      this.store.updateUser(
        data => {
        },
        err => {
          this.$toasted.show(err, { type: "error", duration: 2500 });
        }, () => {
        this.nav.goMaintenance(this)
        }
      );
    },
    sendEmail() {
      this.store.sendEmail(
        data => {
          this.$toasted.show('Email Sent!', { type: "success", duration: 2500 });
        },
        err => {
          this.$toasted.show(err, { type: "error", duration: 2500 });
        }, () => {
        this.nav.goMaintenance(this)
        }
      );
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.favorite-item{
  background: white;
  border-radius: 10px;
  padding:20px;
  margin-top:20px;
  margin-bottom:20px;
}
.white{
  color:white;
}

a {
  color:#FF6F5E; 
}
</style>



// WEBPACK FOOTER //
// src/components/account/MyAccount.vue